import * as Yup from "yup";

export const VALIDATE_BAN_ACCOUNT = Yup.object().shape({
  initiated_by: Yup.string()
    .min(1, "Initiated by is required")
    .required("Initiated by is required"),
  reason: Yup.string()
    .max(100, "Reason description must be less than 100 characters")
    .min(5, "Reason description must be at least 5 characters")
    .required("Reason is required"),
  e2t_refund: Yup.number()
    .typeError("Invalid number")
    .nullable()
    .min(0, "E2T refund must be greater than 0")
    .test("conditional-refund", "E2T refund is required when refund date is set", function (value) {
      const { e2t_refunded } = this.parent;
      if (e2t_refunded !== null && e2t_refunded !== undefined) {
        return value !== null && value !== undefined;
      }
      return true;
    }),
  e2t_refunded: Yup.date()
    .typeError("Invalid date")
    .nullable()
    .test(
      "conditional-refund-date",
      "Refund date is required when E2T refund amount is set",
      function (value) {
        const { e2t_refund } = this.parent;
        if (e2t_refund !== null && e2t_refund !== undefined && e2t_refund > 0) {
          return value !== null && value !== undefined;
        }
        return true;
      }
    ),
});
